import React, { useEffect } from "react"
import { Box, Tabs, Tab, Button } from "@mui/material"
import { useAdministrativeActionsModal } from "../../../contexts/AdministrativeActionsModalContext"
import NotificationTab from "./NotificationTab"
import AnnotationTab from "./AnnotationTab"
import { TabContentContainer } from "./styled"
import { useTranslation } from "react-i18next"

function TabContent({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <TabContentContainer>{children}</TabContentContainer>}
    </div>
  )
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}

const AdministrativeTabs = ({ enableNotifications, enableAnnotations }) => {
  const {
    selectedTab,
    setSelectedTab,
    text,
    setText,
    severity,
    setSeverity,
    SEVERITY,
    status,
    setStatus,
    STATUS,
    users,
    userList,
    loading,
    removeUserFromList,
    selectUser,
    validateDisabledButton,
    handleSendClick,
  } = useAdministrativeActionsModal()
  const { t } = useTranslation('common')

  const handleChange = (_, newValue) => setSelectedTab(newValue)

  const tabs = []
  if (enableNotifications) {
    tabs.push({
      label: t('admin_actions_modal.header.notification'),
      type: "notification",
      component: (
        <NotificationTab
          userList={userList}
          users={users}
          loading={loading}
          selectUser={selectUser}
          removeUserFromList={removeUserFromList}
          text={text}
          setText={setText}
          severity={severity}
          setSeverity={setSeverity}
          SEVERITY={SEVERITY}
        />
      ),
    })
  }
  if (enableAnnotations) {
    tabs.push({
      label: t('admin_actions_modal.header.annotation'),
      type: "annotation",
      component: (
        <AnnotationTab
          userList={userList}
          users={users}
          loading={loading}
          selectUser={selectUser}
          removeUserFromList={removeUserFromList}
          text={text}
          setText={setText}
          severity={severity}
          setSeverity={setSeverity}
          SEVERITY={SEVERITY}
          status={status}
          setStatus={setStatus}
          STATUS={STATUS}
        />
      ),
    })
  }

  useEffect(() => {
    if (tabs.length > 0 && selectedTab >= tabs.length) {
      setSelectedTab(0)
    }
  }, [tabs.length, selectedTab, setSelectedTab])

  if (tabs.length === 0) return null

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={selectedTab} onChange={handleChange} aria-label="tabs">
          {tabs.map((tab, i) => (
            <Tab key={i} label={tab.label} {...a11yProps(i)} />
          ))}
        </Tabs>
      </Box>

      {tabs.map((tab, i) => (
        <TabContent key={i} value={selectedTab} index={i}>
          {tab.component}
        </TabContent>
      ))}
    </Box>
  )
}

export default AdministrativeTabs
